const renderInformation = (information) => {
	const subtitle = document.createElement('div');
	subtitle.setAttribute('class', 'subtitle');
	subtitle.innerText = information.name;

	const content = document.querySelector('.section-half > .content > .content');
	content.appendChild(subtitle);

	const plaintext = document.createElement('div');
	plaintext.setAttribute('class', 'plaintext');

	if (typeof information.content === 'string') {
		plaintext.innerText = information.content;
		content.appendChild(plaintext);
		return;
	}

	let innerHTML = '';
	information.content.forEach((item) => {
		innerHTML = `${innerHTML}${item}<br/>`;
	});
	plaintext.innerHTML = innerHTML;
	content.appendChild(plaintext);
};

export default renderInformation;



// WEBPACK FOOTER //
// ./src/js/restaurant/renderInformation.js